import APIClient from '../factories/APIClient'
import generateDeviceId from '../../generateDeviceId'
import constructRequestData from '../../constructRequestData'

import attachMock from '../factories/attachMock'
import MOCK_RESPONSES from './Register.mock.json'

const client = new APIClient({
  baseURL: process.env.REACT_APP_IDENTITY_API_BASE_URL,
})
const clientExplore = new APIClient({
  baseURL: process.env.REACT_APP_EXPLORE_API_BASE_URL,
})
const clientApi = new APIClient({
  baseURL: process.env.REACT_APP_API_BASE_URL,
})

if (process.env.NODE_ENV === 'development') {
  attachMock(
    client,
    MOCK_RESPONSES,
  )({
    // 'post /register/profile': 200,
    // 'post /register/otp': 200,
    // 'post /register/otp/resend': 200,
    // 'post /register/password': 200,
    // 'post /register/profile/referral': 200,
    // 'post /user/onboarding/email': 200,
    // 'post /password-strength': 200,
  })
}

export const postRegisterProfile = ({ mobileNumber, googleToken, appleId }) => {
  return client({
    url: '/v1/register/profile',
    method: 'post',
    data: constructRequestData({
      mobileNumber,
      googleToken,
      appleId,
    }),
    headers: {
      'X-Device-Id': generateDeviceId(),
    },
  })
}
export const putRegisterProfile = ({
  registrationToken,
  firstName,
  lastName,
  email,
  referralCode,
  avatarUrl,
}) => {
  return client({
    url: '/v1/register/profile',
    method: 'put',
    data: constructRequestData({
      firstName,
      lastName,
      email,
      registrationToken,
      referralCode,
      avatarUrl,
    }),
    headers: {
      'X-Device-Id': generateDeviceId(),
    },
  })
}
export const postVerifyOtp = (
  { registrationToken, code, clientId },
  fcmToken,
) =>
  client({
    method: 'post',
    url: '/v1/register/profile/verify-otp',
    data: constructRequestData({
      registrationToken,
      code,
      clientId: clientId || process.env.REACT_APP_CLIENT_ID,
    }),
    headers: {
      'Fcm-Token': fcmToken,
      'X-Device-Id': generateDeviceId(),
    },
  })

// ST-2873
export const postRegisterV1 = ({
  firstName,
  lastName,
  email,
  mobileNumber,
  googleToken,
  appleId,
  avatarUrl,
  captchaToken,
}) =>
  client({
    url: '/register/profile/v1',
    method: 'post',
    data: constructRequestData({
      firstName,
      lastName,
      email,
      mobileNumber,
      googleToken,
      appleId,
      avatarUrl,
      captchaToken,
    }),
    headers: {
      'X-Device-Id': generateDeviceId(),
    },
  })
export const postRegisterReferral = ({ registrationToken, code }) =>
  client({
    method: 'post',
    url: '/register/profile/referral/v1',
    data: constructRequestData({
      registrationToken,
      code,
    }),
    headers: {
      'X-Device-Id': generateDeviceId(),
    },
  })
export const postRegisterOTP = ({ registrationToken }) =>
  client({
    method: 'post',
    url: '/register/send-otp',
    data: constructRequestData({
      registrationToken,
    }),
    headers: {
      'X-Device-Id': generateDeviceId(),
    },
  })

export const getEmailValidity = email =>
  client({
    method: 'post',
    url: '/register/profile/email-validity',
    data: constructRequestData({ email }),
    headers: {
      'X-Device-Id': generateDeviceId(),
    },
  })

export const getMobileNumberValidity = mobile =>
  client({
    method: 'post',
    url: '/register/profile/mobile-validity',
    data: constructRequestData({ mobile }),
    headers: {
      'X-Device-Id': generateDeviceId(),
    },
  })

export const postRegisterOtpResend = ({ token, toMobile }) =>
  client({
    method: 'post',
    url: 'v1/register/profile/resend',
    data: constructRequestData({
      toMobile,
      registrationToken: token,
    }),
    headers: {
      'X-Device-Id': generateDeviceId(),
    },
  })

export const postAvatar = ({ image }, { accessToken }) =>
  client({
    url: '/user/avatar',
    method: 'post',
    data: constructRequestData(
      {
        image,
      },
      'multipart/form-data',
      {
        filenames: {
          image: 'image.png',
        },
      },
    ),
    headers: {
      Authorization: `Bearer ${accessToken}`,
      'X-Device-Id': generateDeviceId(),
    },
  })

export const checkReferralCode = code =>
  client({
    url: '/register/profile/referral',
    method: 'post',
    data: constructRequestData({
      code,
    }),
    headers: {
      'X-Device-Id': generateDeviceId(),
    },
  })

// ST-4613
export const getRegistrationBanners = () =>
  clientExplore({
    method: 'get',
    url: '/reg-hero-banner',
  })

//DEPRECATED ENDPOINT/S ----------------
export const xx_postRegisterOtp = ({ registrationToken, code }, fcmToken) =>
  client({
    method: 'post',
    url: '/register/otp',
    data: constructRequestData({
      registrationToken,
      code,
    }),
    headers: {
      'Fcm-Token': fcmToken,
      'X-Device-Id': generateDeviceId(),
    },
  })
export const postNominatePassword = (
  { registrationToken, password },
  fcmToken,
) =>
  client({
    method: 'post',
    url: '/register/password',
    data: constructRequestData({
      registrationToken,
      password,
    }),
    headers: {
      'Fcm-Token': fcmToken,
      'X-Device-Id': generateDeviceId(),
    },
  })
